import window from 'global/window';

var atob = function atob(s) {
  return window.atob ? window.atob(s) : Buffer.from(s, 'base64').toString('binary');
};

export default function decodeB64ToUint8Array(b64Text) {
  var decodedString = atob(b64Text);
  var array = new Uint8Array(decodedString.length);

  for (var i = 0; i < decodedString.length; i++) {
    array[i] = decodedString.charCodeAt(i);
  }

  return array;
}


//////////////////
// WEBPACK FOOTER
// ./~/mpd-parser/~/@videojs/vhs-utils/es/decode-b64-to-uint8-array.js
// module id = 2117
// module chunks = 101